import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskProjectDashboardsListRoute } from '@atlassian/jira-router-routes-servicedesk-project-dashboards-routes/src/servicedeskProjectDashboardsListRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	LazyServicedeskProjectDashboardsList,
	ProjectDashboardsList,
} from './ui/dashboard-list/index.tsx';

export const servicedeskProjectDashboardsListRouteEntry = createEntry(
	servicedeskProjectDashboardsListRoute,
	() => ({
		group: 'servicedesk',
		component: ProjectDashboardsList,
		perfMetricKey: 'service-management.project-dashboards.dashboard-list',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskProjectDashboardsList],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-project-dashboards-entries/src/servicedeskProjectDashboardsListRouteEntry.tsx',
				whichExportToUse: 'servicedeskProjectDashboardsListRouteEntry',
			},

			enabled: true,
		},
	}),
);
